import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const ArrowTopRightIcon = ({ className = '', width = 13,  height = 13 , color = 'currentColor' }) => {
    return (
        <svg
            className={`icon-13-13 ${className ? className : ''}`}
            fill='none'
            height={height}
            viewBox='0 0 13 13'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                clipRule='evenodd'
                d='M11.2095 2L3.82904 2L3.82904 2.99175H9.42661L2 10.4184L2.70349 11.1219L10.2121 3.61325V9.3385H11.2095L11.2095 2Z'
                fill={color}
                fillRule='evenodd'/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default ArrowTopRightIcon;
